<template>
    <div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Diagnosis</h5>
                <b-row class="mt-5">
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <div>
                                    <h5 class="font-weight-bold">Primer</h5>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <template v-if="dataRM.kode_diagnosa_primary">
                                <template
                                    v-if="dataRM.kode_diagnosa_primary.id == '34335' || dataRM.kode_diagnosa_primary.kode == 'IZDOTHER'">
                                    <b-col md="12">
                                        <p v-html="dataRM.kode_diagnosa_primary.description"></p>
                                    </b-col>
                                </template>
                                <template v-else>
                                    <b-col md="12" class="font-weight-bold">
                                        {{ `${dataRM.kode_diagnosa_primary.kode} - ${dataRM.kode_diagnosa_primary.description}` }}
                                    </b-col>
                                </template>
                            </template>
                            <template v-else>
                                <b-col md="12">-</b-col>
                            </template>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <div>
                                    <h5 class="font-weight-bold">Sekunder</h5>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <template v-if="dataRM.kode_diagnosa.length > 0">
                                <b-col md="12">
                                    <b-row v-for="(items, index) in dataRM.kode_diagnosa" :key="index">
                                        <b-col md="12" class="font-weight-bold mb-2">
                                            {{ `${items.kode} - ${items.description}` }}
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </template>
                            <template v-else>
                                <b-col md="12">-</b-col>
                            </template>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="mt-5">
                    <b-col md="12">
                        <div class="font-weight-bold">Catatan {{ pcareVersion }}</div>
                        <div v-html="this.dataRM.diagnosa.notes || '-'"></div>
                        <template v-if="dataRM.diagnosa.draw_path !== null">
                            <img :src="dataRM.diagnosa.draw_path" class="img-fluid" alt="img" />
                        </template>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card card-box mb-3" v-if="pcareVersion == '1'">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Prognosa</h5>
                <b-row class="mt-3">
                    <b-col md="12" lg="12">
                        <div v-html="prognosa || '-'"></div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import rekamMedisMixin from "../mixins";
    import { mapGetters } from 'vuex';

    export default {
        name: "Assessment",
        mixins: [rekamMedisMixin],
        props: ["dataRM", "pcareVersion"],
        data() {
            return {
                prognosa: null,
                optPrognosa: [],
            }
        },
        computed: {
            ...mapGetters(['getKlinikId']),
        },
        mounted() {
            this.buildData();
        },
        watch: {
            dataRM() {
                this.buildData()
            }
        },
        methods: {
            buildData() {
                if (this.dataRM) {
                    this.setPrognosa();
                }
            },
            async setPrognosa() {
                this.prognosa = this.dataRM.bpjs_health_data ? this.dataRM.bpjs_health_data.kd_prognosa : null;
                if (this.checkValueData(this.prognosa) && this.pcareVersion == '1') {
                    if (this.optPrognosa.length < 1) this.optPrognosa = await this.fetchPrognosa(this.getKlinikId);
                    const data = this.optPrognosa.find(v => v.value == this.prognosa);
                    if (data) this.prognosa = data.label;
                }
            },
        }
    }
</script>

<style>
    .mb-header {
        margin-bottom: -15px;
    }
</style>